export function creditCardValidation(value: any): boolean {
  let mone: number = 0;
  let incNum: number;

  let luhnChk;

  value = value.toString();

  if (value.length > 13) {
    luhnChk = (luhn: any) => {
      var len = luhn.length,
        mul = 0,
        prodArr = [
          [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
          [0, 2, 4, 6, 8, 1, 3, 5, 7, 9]
        ],
        sum = 0;

      while (len--) {
        sum += prodArr[mul][parseInt(luhn.charAt(len), 10)];

        mul ^= 1;
      }

      return sum % 10 === 0 && sum > 0;
    };
  } else {
    // 8 or 9 digits, isracard only

    if (value.length == 8) {
      value = '0' + value;
    }

    luhnChk = (luhn: any) => {
      var len = luhn.length,
        prodArr = [1, 2, 3, 4, 5, 6, 7, 8, 9],
        sum = 0,
        count = 0;

      while (len--) {
        sum += prodArr[count] * parseInt(luhn.charAt(len), 10);

        count++;
      }

      return sum % 11 === 0 && sum > 0;
    };
  }

  if (/[^0-9-]+/.test(value)) {
    return false;
  }

  return luhnChk(value);
}
